(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    /* Display-only preview. Shopify's automatic discounts remain authoritative. */
if (!customElements.get('oppa-independence-price')) {
  const offerTag = 'independence-offer';
  const eligibility = new Map();
  let cartQuantity;
  let cartRequest;
  let cartReadPending = false;
  let refreshTimer;
  const root = () => window.Shopify?.routes?.root || '/';
  const hasTag = (tags) => (Array.isArray(tags) ? tags : String(tags || '').split(',').map(t => t.trim())).includes(offerTag);

  async function readCartQuantity() {
    if (cartRequest) {
      // A cart mutation can complete while an older cart read is still resolving.
      // Do not drop that update: run one fresh read as soon as this one finishes.
      cartReadPending = true;
      return cartRequest;
    }
    cartRequest = (async () => {
      const response = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      // Product tags are not in the cart AJAX response. Read each distinct product once.
      const handles = [...new Set(cart.items.map(item => item.handle))];
      const results = await Promise.all(handles.map(async handle => {
        if (eligibility.has(handle)) return [handle, eligibility.get(handle)];
        const productResponse = await fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
        if (!productResponse.ok) throw new Error('Product unavailable');
        const product = await productResponse.json();
        const eligible = hasTag(product.tags);
        eligibility.set(handle, eligible);
        return [handle, eligible];
      }));
      const eligibleHandles = new Map(results);
      cartQuantity = cart.items.reduce((total, item) => total + (eligibleHandles.get(item.handle) ? item.quantity : 0), 0);
      document.dispatchEvent(new Event('oppa:offer-cart-ready'));
    })().catch(() => { /* Retain server-rendered cart count if a read fails. */ }).finally(() => {
      cartRequest = null;
      if (cartReadPending) {
        cartReadPending = false;
        scheduleCartRefresh();
      }
    });
    return cartRequest;
  }


  function scheduleCartRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(readCartQuantity, 80);
  }

  // Watch completed cart writes, including cart-drawer quantity changes/removals.
  // This is independent of the event names used by a particular Savor version.
  // Reading /cart.js is excluded, so refreshes cannot trigger themselves.
  let observesCartRequests = false;
  if (typeof PerformanceObserver !== 'undefined') {
    try {
      const cartWrites = new PerformanceObserver(list => {
        const changed = list.getEntries().some(entry => {
          try {
            const url = new URL(entry.name, window.location.href);
            return url.origin === window.location.origin && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
          } catch { return false; }
        });
        if (changed) scheduleCartRefresh();
      });
      cartWrites.observe({ type: 'resource', buffered: false });
      observesCartRequests = true;
    } catch { /* Fall back to periodic reads in older browsers. */ }
  }
  if (!observesCartRequests) {
    setInterval(() => {
      if (!document.hidden && document.querySelector('oppa-independence-price')) scheduleCartRefresh();
    }, 2000);
  }

  class IndependencePrice extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      try { this.prices = JSON.parse(this.querySelector('[data-offer-prices]').textContent); }
      catch { return; }
      this.scope = this.closest('product-card, product-information, product-info, quick-add-dialog, .shopify-section') || this.parentElement;
      this.renderOffer = this.renderOffer.bind(this);
      this.renderOffer();
      // Delegation survives changes to quantity inputs and variant pickers.
      ['input', 'change', 'click', 'variant:update', 'variant:change', 'quantity:update'].forEach(name => {
        this.scope.addEventListener(name, () => requestAnimationFrame(this.renderOffer), options);
      });
      document.addEventListener('oppa:offer-cart-ready', this.renderOffer, options);
      // Theme events provide an additional refresh path.
      ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh'].forEach(name => {
        document.addEventListener(name, scheduleCartRefresh, options);
      });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) readCartQuantity(); }, options);
      window.addEventListener('pageshow', readCartQuantity, options);
      // Observe variant form updates that do not emit native input/change events.
      this.observer?.disconnect();
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.renderOffer();
      });
      this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'data-selected-variant'] });
      readCartQuantity();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }

    renderOffer() {
      if (!this.isConnected || !this.prices) return;
      const isCard = !!this.closest('product-card');
      const forms = [...this.scope.querySelectorAll('form[action*="/cart/add"]')];
      const form = forms.find(candidate => !candidate.classList.contains('payment-terms') && candidate.querySelector('[name="id"]'));
      const variantInput = form?.querySelector('[name="id"]');
      const variantId = variantInput?.value || this.dataset.initialVariant;
      const quantityInput = !isCard && (form?.querySelector('input[name="quantity"]') || this.scope.querySelector('quantity-selector input[name="quantity"], input[name="quantity"]'));
      const quantity = Math.max(1, Number(quantityInput?.value) || 1);
      const inCart = cartQuantity ?? this.prices.cartQuantity;
      const percent = inCart + quantity >= 2 ? 50 : 25;
      const range = this.dataset.range === 'true' && (isCard || !variantInput);
      const prices = range ? this.prices.range : this.prices.variants[variantId];
      if (!prices) return;
      // Money strings come from Shopify Liquid, retaining the store's format/currency.
      this.querySelector('[data-offer-regular]').innerHTML = prices.regular;
      this.querySelector('[data-offer-current]').innerHTML = percent === 50 ? prices.multiple : prices.single;
      this.querySelector('[data-offer-badge]').textContent = 'Save ' + percent + '%';
      this.querySelector('[data-offer-display]').hidden = false;
      const native = this.parentElement.querySelector('[data-offer-native]');
      if (native) native.hidden = true;
    }
  }
  customElements.define('oppa-independence-price', IndependencePrice);
}
  } catch(e) { console.error(e); }
})();

})();
